import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {

  public _Approval = environment.Approval;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"];
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };
}
GetPageInitializeDetails(): Observable<any>{
   

  var Query = this._Approval;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}
Approval(approval:object): Observable<any>{
 

  var Query = this._Approval + "/ApprovePreQuote";
  // console.log(Query);
  return this.http.post<{ data: any }>(Query, approval, this._httpOptions);
}

CustomerConreactGetById(customerSiteId:string,documenttypecode:string): Observable<any>{
  var Query = this._Approval + '/CustomerConreactGetById' +'/'+ customerSiteId +'/'+ documenttypecode;
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}

CustomerContractApproval(approval:object): Observable<any>{
 

  var Query = this._Approval + "/CustomerContractApprove";
  // console.log(Query);
  return this.http.post<{ data: any }>(Query, approval, this._httpOptions);
}
customerContractApprovalRefer(approval:object): Observable<any>{
 

  var Query = this._Approval + "/CustomerContractApproveReferBack";
  // console.log(Query);
  return this.http.post<{ data: any }>(Query, approval, this._httpOptions);
}
customerContractApprovalReject(approval:object): Observable<any>{
 

  var Query = this._Approval + "/CustomerContractApproveReject";
  // console.log(Query);
  return this.http.post<{ data: any }>(Query, approval, this._httpOptions);
}
}
